import styled from "styled-components";

export const Span = styled.span`
  font-family: "Thasadith", sans-serif;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  // font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : 400)}
`;
